/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Typography } from '@mui/material'
import { connect } from 'react-redux'
import IntlMessages from '../../../../util/IntlMessages'
import useStyles from './style'

function Content(props) {
    const classes = useStyles()

    return (
        <>
            <Typography variant='h1' className={classes.content}>
                <IntlMessages id="routing" />
            </Typography>
            <Typography variant='h4' className={classes.message}>
                <IntlMessages id="dearUserIfYouHaveAnyFollowingRoutersInstalledOnYourMobilePhoneClickIt" />
            </Typography>
        </ >
    )
}

const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Content)